import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Collapse, IconButton, Container } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../api';

export default function SystemAnnouncement() {
    const [announcement, setAnnouncement] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fetchAnnouncement = async () => {
            try {
                const response = await api.get('/settings/feature-flags/');
                
                // FIX: Gestione della paginazione nativa di DRF (cerchiamo in '.results')
                const flagsDict = response.data.results || response.data;
                const flag = flagsDict.find(setting => setting.key === 'FEATURE_SYSTEM_ANNOUNCEMENT');
                
                if (!flag || !flag.value) return; // Controllo null-safety rinforzato

                // Parsing sicuro del Textarea field dal backend che ora viene trasmesso
                const data = typeof flag.value === 'string' 
                                ? JSON.parse(flag.value) 
                                : flag.value;

                const dismissedId = localStorage.getItem('dimissed_announcement_id');

                if (data?.isActive && data.id !== dismissedId) {
                    setAnnouncement(data);
                    setOpen(true);
                }
            } catch {
                console.debug("Salto annuncio di sistema globale o formato JSON scorretto.");
            }
        };

        fetchAnnouncement();
    }, []);

    const handleDismiss = () => {
        setOpen(false);
        if (announcement?.id) {
            localStorage.setItem('dimissed_announcement_id', announcement.id);
        }
    };

    if (!announcement) return null;

    return (
        <Container maxWidth="xl" sx={{ mt: 2 }}>
            <Collapse in={open}>
                <Alert
                    severity={announcement.severity || "info"}
                    action={
                        <IconButton
                            aria-label="Nascondi avviso"
                            color="inherit"
                            size="small"
                            onClick={handleDismiss}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{
                        boxShadow: 2,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {announcement.title && <AlertTitle sx={{ mb: 0.5, fontWeight: 'bold' }}>{announcement.title}</AlertTitle>}
                    {announcement.message}
                </Alert>
            </Collapse>
        </Container>
    );
}